import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { VesselCalculationInventoryService } from 'src/app/services/danish-shipping-services/vessel-calculation-inventory.service';

@Component({
  selector: 'app-energy-options',
  templateUrl: './energy-options.component.html',
  styleUrls: ['./energy-options.component.css']
})
export class EnergyOptionsComponent implements OnInit {
  energyOptions: any[] = [];
  filteredEnergyOptions: any[] = [];
  searchTerm: string = '';

  constructor(
    private vesselCalculationInventoryService: VesselCalculationInventoryService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadEnergyOptions();
  }

  loadEnergyOptions(): void {
    this.vesselCalculationInventoryService.getEnergyOptions().subscribe(
      (response) => {
        this.energyOptions = response;
        this.filteredEnergyOptions = [...response];
      },
      (error) => {
        console.error('Error fetching Energy Options:', error);
      }
    );
  }

  filterOptions(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredEnergyOptions = this.energyOptions.filter(option =>
      option.title.toLowerCase().includes(term)
    );
  }

  deleteEnergyOption(id: string): void {
    if (confirm('Are you sure you want to delete this energy option?')) {
      this.vesselCalculationInventoryService.deleteEnergyOption(id).subscribe(
        () => {
          this.toastr.success('Energy option deleted successfully!');
          this.loadEnergyOptions();
        },
        (error) => {
          console.error('Error deleting Energy Option:', error);
          this.toastr.error('Failed to delete energy option.');
        }
      );
    }
  }
}
